import { render, staticRenderFns } from "./u-dialog-flat-tile.vue?vue&type=template&id=3b46ea8f&scoped=true&"
import script from "./u-dialog-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-dialog-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b46ea8f",
  null
  
)

export default component.exports